import script from "./EmployeeCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeCategory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__